<!--
  A card of its own between the header card and the task card (leaflet-newcollections), shown only
  once the server has said "Add to STAC" is there for this user and task (StacConversionService),
  and not where Sync Data Catalog is switched on for none of the task's sensors, or none of them has
  a delivered scene yet (`covered`), nor once the task's processing is done with every scene in the
  catalog or not available, and nothing left to say (`complete`). Everything is in plain sight: the
  lines say the task's state, including that archived scenes need a restore first (`restoreFirst`),
  and the button syncs. The lines are a live region, so a screen reader hears a change of state as a
  sighted user sees it. The button shows only when a sync has something to fix.
-->
<section class="stac-banner" *ngIf="view && visible" [class.is-active]="active" [attr.aria-label]="TITLE">
  <mat-icon class="stac-banner-icon material-icons-outlined" aria-hidden="true">cloud_upload</mat-icon>
  <div class="stac-banner-body">
    <div class="stac-banner-title">{{ TITLE }}</div>
    <div class="stac-banner-lines" role="status" aria-live="polite">
      <p *ngFor="let line of lines; trackBy: trackLine" class="stac-banner-line" [ngClass]="'tone-' + line.tone">
        <mat-icon *ngIf="iconOf(line) as icon" class="stac-banner-line-icon material-icons-outlined" aria-hidden="true">{{ icon }}</mat-icon>
        <span>{{ line.text }}</span>
      </p>
    </div>
  </div>
  <!-- Styled as the Reports button is. Only when a sync has something to fix (needsSync, D6), and
       kept through its own press until the state read after it says otherwise. -->
  <button *ngIf="needsSync || pressing" mat-raised-button type="button" class="action-button submit stac-add" [disabled]="active || pressing" (click)="press()">
    {{ LABEL }}
  </button>
  <!-- Along the strip's bottom edge while a request is queued or running: the delivered scenes
       counted through. -->
  <mat-progress-bar
    *ngIf="progress as p"
    class="stac-banner-progress"
    mode="determinate"
    [value]="p.percent"
    [attr.aria-label]="p.done + ' of ' + p.total + ' delivered scenes processed'"
  ></mat-progress-bar>
</section>
